import get from "lodash/get"
import {
  SET_ELIGIBILITY_FLAGS,
  SET_MY_WM_CUSTOMER_ID,
  SET_RENDER_MY_WM_OPTIONS,
  SET_USE_MASKED_CUSTOMER_ID,
  SET_USE_PAYMENT_CUSTOMER_ID,
  RESET_DASHBOARD_FROM_GETTING_STARTED,
  GET_LINKED_ACCOUNTS_FULFILLED,
  SET_LINKED_ACCOUNTS_FULFILLED,
  SET_UNLINKED_ACCOUNTS_FULFILLED,
  SET_USER_STATE,
} from "constants-lib/actionTypes"
import { userType } from "constants-lib/authentication"

const initialState = {
  renderMyWMOptions: false,
  selectedCustomerId: ``,
  useMaskedCustomerID: false,
  usePaymentCustomerID: false,
  eligibilityCode: {
    eligibleForMyServices: ``,
    eligibleForBillPay: ``,
    eligibleForCommPrefs: ``,
  },
  numLinkedAccounts: 0,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ELIGIBILITY_FLAGS:
      return {
        ...state,
        eligibilityCode: {
          eligibleForMyServices: action.payload.eligibleForMyServices,
          eligibleForBillPay: action.payload.eligibleForBillPay,
          eligibleForCommPrefs: action.payload.eligibleForCommPrefs,
        },
      }

    case SET_MY_WM_CUSTOMER_ID:
      return {
        ...state,
        selectedCustomerId: action.payload,
      }

    case SET_RENDER_MY_WM_OPTIONS:
      return {
        ...state,
        renderMyWMOptions: action.payload,
      }

    case SET_USE_MASKED_CUSTOMER_ID:
      return {
        ...state,
        useMaskedCustomerID: action.payload,
      }

    case SET_USE_PAYMENT_CUSTOMER_ID:
      return {
        ...state,
        usePaymentCustomerID: action.payload,
      }

    case RESET_DASHBOARD_FROM_GETTING_STARTED:
      return {
        ...initialState,
      }

    case GET_LINKED_ACCOUNTS_FULFILLED: {
      return {
        ...state,
        numLinkedAccounts: get(action.payload, `linkedAccounts`, []).length,
      }
    }

    case SET_LINKED_ACCOUNTS_FULFILLED: {
      return {
        ...state,
        numLinkedAccounts: action.payload.numLinkedAccounts,
      }
    }

    case SET_UNLINKED_ACCOUNTS_FULFILLED: {
      return {
        ...state,
        numLinkedAccounts: action.payload.numLinkedAccounts,
      }
    }

    case SET_USER_STATE: {
      /* Clear state after logging in. */
      if (action.payload === userType.LOGGED_IN) {
        return {
          ...initialState,
        }
      }
      return {
        ...state,
      }
    }

    default:
      return state
  }
}
